import moment from 'moment';

export default function PmBoardApproveDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  loaderService,
  pmDataService,
  reportsDataService,
  ssDialogService,
) {
  const vm = this;
  vm.handleSubmit = _handleSubmit;
  vm.handleClose = _handleClose;

  _activate();

  /** ************************************************
   * Event Handlers
   */

  function _handleSubmit() {
    if ($scope.pmBoardApproveForm.$invalid) {
      return;
    }
    vm.boardApprovedDate = vm.boardApprovedCurrentDate.format('MM/DD/YYYY');
    loaderService.showViewLoader = true;
    pmDataService.approveDocument(vm.policyDocumentId, vm.approvedById, vm.boardApprovedDate).then((response) => {
      loaderService.showViewLoader = false;
      if (!response.data.result) {
        alerts.error('Error occurred while saving the Board Approval.');
      } else {
        alerts.success('The Policy Document is Board Approved successfully.');
        $rootScope.$broadcast('activeDocumentApproved', { policyDocumentId: vm.policyDocumentId });
        alerts.info('Please Wait! Updating document with Approved date. This may take a while');
        _generateDocumentAndDownload();
        _closeDialog();
      }
    }).catch(() => {
      loaderService.showViewLoader = false;
      alerts.error('Error occurred while saving the Board Approval.');
    });
  }

  function _handleClose() {
    _closeDialog();
  }

  /** ************************************************
   * Private Functions
   */

  function _activate() {
    vm.approvedById = -1;
    vm.boardApprovedMinDate = moment().add(-18, 'months');
    vm.boardApprovedCurrentDate = moment().add(0, 'days');
    vm.boardApprovedMaxDate = vm.boardApprovedCurrentDate;
    vm.boardApprovedDate = vm.boardApprovedCurrentDate.format('MM/DD/YYYY');
    vm.confirmSubmit = false;
  }

  function _generateDocumentAndDownload() {
    loaderService.showViewLoader = true;
    pmDataService.generateFullReport(
      {
        policyDocumentId: vm.policyDocumentId,
        name: vm.documentName,
        renderFullReport: true,
        saveDocument: true,
      },
      ''
    ).then((response) => {
      loaderService.showViewLoader = false;
      alerts.success('The Policy Document is updated successfully.');
      $rootScope.$broadcast('refreshPMDocuments');
      reportsDataService.download(response);
    });
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pm.boardApproveDialog);
  }
}

PmBoardApproveDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'loaderService',
  'pmDataService',
  'reportsDataService',
  'ssDialogService',
];
